var collectionObject = {
  "Pro Audio": {
    "Powered Speakers": ["CVE Series", "CVX Series", "CVXL Series"],
    "Passive Speakers": ["CVI Portable", "Intense"],
    "Studio Monitors":["Vega Studio Monitor"],
    "Mixers":["CVM Mixer"],
    "Headphones": ["HB Wired Series", "VegaBuds"]    
  },
  "Home Audio": {
    "Hi Fi Speakers and Subs": ["SL Series", "XLS Series", "LA Series"],
    "Headphones": ["HB Wired Series", "VegaBuds"],
    "Home Theater Systems":["Studio Monitors"],
    "Portable Speakers":["VegaMini"],
  },
  "Amplifier": {
    "Stroker Pro Amplifier": ["Stroker Pro Amplifier"],
    "Stroker Amplifier": ["S9500.2D","S9600.4D","S9750.1D","S9100.1D","S91100.5D","S91500.1D"],
    "RPM Stroker Amplifier": [""],
    "RPM HED Amplifier": [""],
    "Vega Amplifier": [""],
    "Stealth Bomber": [""],
    "HED Amplifier": [""],
    "XED Amplifier": [""],
    "CVP Amplifier": [""],
    "CVPM Amplifier": [""],
    "Pro Amplifier": [""],
    "Digital Sound Processors": [""],
  },
  "Speaker": {
    "RPM Stroker Speaker": [""],
    "RPM Vega Speaker": [""],
    "RPM XED Speaker": [""],
    "Stroker Speaker": [""],
    "Vega Speaker": [""],
    "HED Speaker": [""],
    "XED Speaker": [""],
    "CVP Speaker": [""],
    "Pro Speaker": [""],
    "CVPX Series": [""],
  },
  "Subwoofer": {
    "CVP Subwoofer": [""],
    "HED Subwoofer": [""],
    "RPM Subwoofer": [""],
    "Stroker Pro Classic": [""],
    "Stroker Subwoofer": [""],
    "Vmaxx Subwoofer": [""],
    "Vega Subwoofer": [""],
    "Vega Pro Subwoofer": [""],
    "XED Subwoofer": [""],
  }
}
window.onload = function() {
  var collectionSel = document.getElementById("collection");
  var seriesSel = document.getElementById("series");
  var modelSel = document.getElementById("model");
  var searchbar = document.getElementById("search");
  var resetManual = document.getElementById("reset-manual");

  // This script is only relevant on the "Download Manuals" page. On every
  // other page these elements don't exist, which was throwing
  // "Cannot read properties of null (reading 'options')" on every page load.
  if (!collectionSel || !seriesSel || !modelSel || !searchbar || !resetManual) {
    return;
  }

  for (var x in collectionObject) {
    collectionSel.options[collectionSel.options.length] = new Option(x, x);
  }
  collectionSel.onchange = function() {
    //empty models- and seriess- dropdowns
    modelSel.length = 1;
    seriesSel.length = 1;
    //display correct values
    for (var y in collectionObject[this.value]) {
      seriesSel.options[seriesSel.options.length] = new Option(y, y);
    }
  }
  seriesSel.onchange = function() {
    //empty models dropdown
    modelSel.length = 1;
    //display correct values
    var z = collectionObject[collectionSel.value][this.value];
    for (var i = 0; i < z.length; i++) {
      modelSel.options[modelSel.options.length] = new Option(z[i], z[i]);
    }
  }
  modelSel.onchange = function(e) {
    const term = e.target.value.toLowerCase();
    const items = document.getElementsByClassName("item");
    Array.from(items).forEach((item) => {
      const title = item.firstElementChild.textContent;
      if(title.toLocaleLowerCase().indexOf(term) != -1){
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    })
  }

  searchbar.onkeyup = function(e) {
    const term = e.target.value.toLowerCase();
    const items = document.getElementsByClassName("item");
    Array.from(items).forEach((item) => {
      const title = item.firstElementChild.textContent;
      if(title.toLocaleLowerCase().indexOf(term) != -1){
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    })
  }

  resetManual.onclick = function(){
    const items = document.getElementsByClassName("item");
    Array.from(items).forEach((item) => {
      item.style.display = 'none';
    })
  }
}
